import VideoCardDescription from "./VideoCardDescription";
export default VideoCardDescription;
